import { ExtraContentContent } from '@components/enrollments/courses/extra_contents/ExtraContentContent'
import { CourseProvider } from '@contexts/CourseContext'
import { EnrollmentProvider } from '@contexts/EnrollmentContext'
import { ExtraContentsProvider } from '@contexts/ExtraContentsContext'
import { LessonExtraContentsProvider } from '@contexts/LessonExtraContentsContext'
import { AppLayout } from '@layouts/AppLayout'
import { useUpNavigation } from '@hooks/useUpNavigation'
import { useLocalSearchParams } from 'expo-router'
import { H1, Stack, useMedia, XStack } from 'tamagui'

/** Material complementar, compartilhado entre aluno e preview do produtor. */
export function ExtraContentsScreen() {
  const local = useLocalSearchParams<{ courseName: string }>()
  const media = useMedia()
  const goUp = useUpNavigation()

  return (
    <CourseProvider>
      <EnrollmentProvider>
        <LessonExtraContentsProvider>
          <ExtraContentsProvider>
            <AppLayout
              backRoute={{
                label: local.courseName || 'Voltar para o curso',
                back: goUp,
              }}
            >
              <Stack>
                <XStack
                  backgroundColor="$bg-chrome"
                  paddingHorizontal="$size.spacing-xs"
                  paddingVertical="$size.spacing-md"
                  paddingTop="$size.spacing-xxl"
                  $gtSm={{
                    paddingBottom: '$size.spacing-xl',
                  }}
                  $gtMd={{
                    paddingHorizontal: '$size.spacing-xsl',
                  }}
                >
                  <H1
                    fontSize={media.gtSm ? '$font-size-lg' : '$font-size-md'}
                    color="$text-primary"
                    ff="$mulishBold"
                  >
                    Material Complementar
                  </H1>
                </XStack>
                <Stack
                  backgroundColor="$bg-page"
                  p={'$size.spacing-xs'}
                  $gtSm={{
                    padding: '$size.spacing-xs',
                  }}
                  $gtMd={{
                    padding: '$size.spacing-xl',
                  }}
                >
                  <ExtraContentContent />
                </Stack>
              </Stack>
            </AppLayout>
          </ExtraContentsProvider>
        </LessonExtraContentsProvider>
      </EnrollmentProvider>
    </CourseProvider>
  )
}
